"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreespinsCards = void 0;
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var balance_1 = require("../balance");
var useActivateFreespins_1 = require("./useActivateFreespins");
var useCancelFreespins_1 = require("./useCancelFreespins");
var useFreespins_1 = require("./useFreespins");
var useFreespinsCards = function () {
    var router = (0, navigation_1.useRouter)();
    var data = (0, balance_1.useBalance)().data;
    var _a = (0, react_1.useState)(false), isOpenCongratulations = _a[0], setOpenCongratulations = _a[1];
    var _b = (0, useFreespins_1.useFreespins)(data === null || data === void 0 ? void 0 : data.currency), freespins = _b.data, isFreespinsLoading = _b.isLoading, isFreespinsValidation = _b.isValidating;
    var _c = (0, react_1.useState)(null), freespinsToCancel = _c[0], setFreespinsToCancel = _c[1];
    var _d = (0, react_1.useState)(null), freespinsToActivate = _d[0], setFreespinsToActivate = _d[1];
    var _e = (0, react_1.useState)(null), freespinsToDirectActivation = _e[0], setFreespinsToDirectActivation = _e[1];
    var cancelFreespinsHandler = (0, react_1.useCallback)(function (bonus) {
        setFreespinsToCancel(bonus);
    }, []);
    var closeCancelFreespinsModal = (0, react_1.useCallback)(function () {
        setFreespinsToCancel(null);
    }, []);
    var closeCongratulations = (0, react_1.useCallback)(function () {
        setOpenCongratulations(false);
    }, []);
    var openCongratulations = (0, react_1.useCallback)(function () {
        setOpenCongratulations(true);
    }, []);
    var _f = (0, useCancelFreespins_1.useCancelFreespins)({
        successAction: function () {
            closeCancelFreespinsModal();
            router.refresh();
        },
    }), cancelFreespins = _f.cancelFreespins, isCancelingFreespins = _f.isSubmitting;
    var _g = (0, useActivateFreespins_1.useActivateFreespins)({
        successAction: function () {
            closeActivateFreespinsModal();
            setFreespinsToDirectActivation(null);
            openCongratulations();
            router.refresh();
        },
    }), activateFreespins = _g.activateFreespins, isActivateSubmitting = _g.isSubmitting;
    var confirmCancelFreespins = (0, react_1.useCallback)(function () {
        if (freespinsToCancel === null || freespinsToCancel === void 0 ? void 0 : freespinsToCancel.bonusId) {
            cancelFreespins({ bonusId: freespinsToCancel.bonusId });
        }
    }, [freespinsToCancel, cancelFreespins]);
    var closeActivateFreespinsModal = (0, react_1.useCallback)(function () {
        setFreespinsToActivate(null);
    }, []);
    var confirmActivateFreespins = (0, react_1.useCallback)(function (freespins) {
        if (freespinsToActivate === null || freespinsToActivate === void 0 ? void 0 : freespinsToActivate.bonusId) {
            activateFreespins({ bonusId: freespinsToActivate.bonusId });
        }
        else if (freespins === null || freespins === void 0 ? void 0 : freespins.bonusId) {
            activateFreespins({ bonusId: freespins.bonusId });
            setFreespinsToDirectActivation(freespins);
        }
    }, [setFreespinsToDirectActivation, freespinsToActivate, activateFreespins]);
    var activateFreespinsHandler = (0, react_1.useCallback)(function (bonus) {
        if (!bonus)
            return;
        setFreespinsToActivate(bonus);
    }, [setFreespinsToActivate]);
    return (0, react_1.useMemo)(function () { return ({
        freespins: freespins || [],
        cancelFreespinsHandler: cancelFreespinsHandler,
        closeCancelFreespinsModal: closeCancelFreespinsModal,
        confirmCancelFreespins: confirmCancelFreespins,
        isCancelingFreespins: isCancelingFreespins,
        closeActivateFreespinsModal: closeActivateFreespinsModal,
        isActivateSubmitting: isActivateSubmitting,
        freespinsToDirectActivation: freespinsToDirectActivation,
        confirmActivateFreespins: confirmActivateFreespins,
        activateFreespinsHandler: activateFreespinsHandler,
        freespinsToCancel: freespinsToCancel,
        freespinsToActivate: freespinsToActivate,
        isLoading: isFreespinsLoading,
        isValidation: isFreespinsValidation,
        isOpenCongratulations: isOpenCongratulations,
        closeCongratulations: closeCongratulations,
    }); }, [
        closeCongratulations,
        isOpenCongratulations,
        freespins,
        cancelFreespinsHandler,
        closeCancelFreespinsModal,
        confirmCancelFreespins,
        isCancelingFreespins,
        closeActivateFreespinsModal,
        isActivateSubmitting,
        freespinsToDirectActivation,
        confirmActivateFreespins,
        activateFreespinsHandler,
        freespinsToCancel,
        freespinsToActivate,
        isFreespinsLoading,
        isFreespinsValidation,
    ]);
};
exports.useFreespinsCards = useFreespinsCards;
